import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';

import { Swiper, SwiperSlide } from 'swiper/react';

import { BlockContent } from '../Block';
import { Caption } from './styles';
import { Pagination } from 'swiper';
import PropTypes from 'prop-types';
import React from 'react';
import SliderControls from './SliderControls';

const Slider = ({ children, caption, showControls, ...settings }) => {
  const [isEnd, setIsEnd] = React.useState(false);
  const [isBeginning, setIsBeginning] = React.useState(true);
  const [currentIndex, setCurrentIndex] = React.useState(false);
  const renderSlide = (slide, index) => {
    return <SwiperSlide key={index}>{slide}</SwiperSlide>;
  };

  const renderSlides = slides => {
    return slides.map(renderSlide);
  };

  return (
    <React.Fragment>
      <Swiper
        modules={[Pagination]}
        slidesPerView={2}
        spaceBetween={40}
        onActiveIndexChange={swiper => {
          setCurrentIndex(swiper.activeIndex);
          setIsEnd(swiper.isEnd);
          setIsBeginning(swiper.isBeginning);
        }}
        onSwiper={swiper => {
          setCurrentIndex(swiper.activeIndex);
          setIsEnd(swiper.isEnd);
          setIsBeginning(swiper.isBeginning);
        }}
        pagination={{
          clickable: true,
          el: '.swiper-slider-pagination',
          type: 'bullets',
          bulletClass: 'swiper-bullet',
          bulletActiveClass: 'swiper-bullet-active'
        }}
        {...settings}
      >
        {renderSlides(children)}
        {caption && (
          <Caption>
            <BlockContent color="#05425E" wysiwyg>
              {caption}
            </BlockContent>
          </Caption>
        )}
        {showControls && (
          <SliderControls
            isEnd={isEnd}
            isBeginning={isBeginning}
            currentIndex={currentIndex}
          />
        )}
      </Swiper>
    </React.Fragment>
  );
};

Slider.defaultProps = {
  showControls: true
};

Slider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  infinite: PropTypes.bool,
  unslick: PropTypes.bool,
  showControls: PropTypes.bool
};

export default Slider;
